<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<h1 class="c-modal__title c-text c-text--xl" *ngIf="vm.isInitialized">{{ 'Symptom_Check.Results_Title' | translate }}</h1>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="headerCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content" [ngClass]="{'u-no-pb': !vm.isDoctor}" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div *ngIf="vm.isInitialized">
					<div class="o-media u-ost-md">
						<div class="o-media__img">
							<div class="c-thumb">
								<avatar [user]="vm.interview.user" size="sm"></avatar>
							</div>
						</div>
						<div class="o-media__body">
							<p class="c-text c-text--lg c-text--bold">{{vm.interview.user.firstname}} {{vm.interview.user.lastname}}</p>
							<p class="c-text u-ost-xs" *ngIf="vm.interview.selfTest">
								{{ vm.interview.age }}, {{ ('Common.' + (vm.interview.sex | capitalize)) | translate }}
							</p>
							<div class="o-grid u-ost-xs">
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pl">
									<span class="c-text c-text--main"><i class="o-icon o-icon--clock-alt" aria-hidden="true"></i></span>
								</div>
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--gray">{{ vm.interview.created | date: 'dd.MM.yyyy HH:mm' }}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="u-osb-xxl u-ost-xxl" *ngIf="!vm.interview.selfTest">
						<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Check_For' | translate }}</h2>
						<p class="c-text c-text--spaced u-osb-sm">{{ vm.interview.age }}, {{ ('Common.' + (vm.interview.sex | capitalize)) | translate }}</p>
					</div>
					<div class="u-osb-xxl u-ost-xxl" *ngIf="vm.conditions?.length">
						<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Possible_Conditions' | translate }}</h2>
						<div class="o-grid o-grid--wrap u-osb-sm" *ngFor="let condition of vm.conditions ; let $index=index">
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-55@md-and-up u-no-p@up-to-md u-no-pl"
									 [ngSwitch]="vm.hasTreatmentGuideline(condition.condition.id)">
								<button id="treatmentGuideButton{{$index}}" type="button" class="c-button c-button--link u-text-left" *ngSwitchCase="true" (click)="vm.openTreatmentGuideline(condition.condition.id)">
									{{condition.condition.common_name}} {{'Symptom_Check.Results.Read_More' | translate}}
								</button>
								<p class="c-text" *ngSwitchDefault>{{condition.condition.common_name}}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-85@sm-and-up o-grid__cell--w-35@md-and-up u-no-p@up-to-md"
									 style="cursor: pointer" (click)="vm.openConditionInfo(condition)">
								<item-progress [value]="condition.probability" [max]="1"></item-progress>
							</div>
							<div id="conditionInfoButton{{$index}}" class="o-grid__cell o-grid__cell--w-20 o-grid__cell--w-15@sm-and-up o-grid__cell--w-10@md-and-up u-no-pr"
									 style="cursor: pointer" (click)="vm.openConditionInfo(condition)">
								<p class="c-text c-text--right">{{condition.probability * 100 | number: '1.1-1'}}%</p>
							</div>
						</div>
						<div class="u-osb-xxl u-ost-xxl" *ngIf="vm.genericFactors?.length">
							<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Generic_Risk_Factors' | translate }}</h2>
							<div class="u-osb-sm" *ngFor="let factor of vm.genericFactors ; let $index=index">
								<p class="c-text c-text--spaced">{{ factor.common_name }}</p>
							</div>
						</div>
						<div class="u-osb-xxl u-ost-xxl" *ngIf="vm.locationFactors?.length">
							<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Location_Risk_Factors' | translate }}</h2>
							<div class="u-osb-sm" *ngFor="let factor of vm.locationFactors ; let $index=index">
								<p class="c-text c-text--spaced">{{ factor.common_name }}</p>
							</div>
						</div>
						<div class="u-osb-xxl u-ost-xxl" *ngIf="vm.initialFactors?.length">
							<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Initial_Symptoms' | translate }}</h2>
							<div class="u-osb-sm" *ngFor="let factor of vm.initialFactors ; let $index=index">
								<p class="c-text c-text--spaced">{{ factor.common_name }}</p>
							</div>
						</div>
						<div class="u-ost-xxl" *ngIf="vm.questions?.length">
							<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Questions' | translate }}</h2>
							<ol class="c-list c-list--ol">
								<li class="c-list__item u-osb-sm" *ngFor="let question of vm.questions ; let $index=index">
									<div class="u-osl-lg" [ngSwitch]="question.type">
										<div *ngSwitchCase="'group_multiple'">
											<p class="c-text c-text--spaced">{{ question.text }}</p>
											<div class="o-grid u-ost-sm" *ngFor="let item of question.items">
												<div class="o-grid__cell o-grid__cell--w-60">
													<p class="c-text c-text--spaced">- {{ item.common_name || item.name }}</p>
												</div>
												<div class="o-grid__cell o-grid__cell--w-40 u-no-pr">
													<p class="c-text c-text--spaced c-text--right">{{ vm.getSingleItem(item).label }}</p>
												</div>
											</div>
										</div>
										<div class="o-grid" *ngSwitchDefault>
											<div class="o-grid__cell o-grid__cell--w-60 u-no-pl">
												<p class="c-text c-text--spaced">{{ question.text }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-40 u-no-pr">
												<p class="c-text c-text--spaced c-text--right" [ngSwitch]="question.type">
													<span *ngSwitchCase="'single'">{{ vm.getSingleItem(question.items[0]).label }}</span>
													<span *ngSwitchCase="'group_single'">{{ vm.getSingleGroupItem(question).name }}</span>
												</p>
											</div>
										</div>
									</div>
								</li>
							</ol>
						</div>
						<div class="u-ost-xxl u-osb-xl" *ngIf="vm.isDoctor && vm.interview?.rating?.rating">
							<h2 class="c-text c-text--gray c-text--uppercase c-text--md u-osb-lg">{{ 'Symptom_Check.Results_Rating' | translate }}</h2>
							<item-rating [model]="vm.interview?.rating?.rating" [maxRating]="10"></item-rating>
						</div>
					</div>
					<div class="o-grid" *ngIf="vm.isDoctor && vm.isInitialized">
						<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
							<button id="closeButton" type="button" class="c-button c-button--s6 c-button--fit" (click)="vm.close()">{{ 'Common.Back' | translate }}</button>
						</div>
						<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up">
							<button id="symptomRatingButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.openSymptomRatingModal()">{{ 'Common.Rate' | translate }}</button>
						</div>
					</div>
					<loader-overlay *ngIf="!vm.isInitialized"></loader-overlay>
				</div>
			</div>
		</div>
	</div>
</div>
